export enum NewsSectionType {
  RcArticles = 'rc',
  UsExternalNews = 'externalUs',
  NonUsExternalNews = 'externalNonUs',
}
